<div class="version-select-container">
  <mat-form-field appearance="fill">
    <mat-label>Vælg version</mat-label>
    <mat-select
      [(ngModel)]="selectedVersionId"
      (selectionChange)="onVersionChange($event.value)"
      [compareWith]="compareVersions"
    >
      @for (version of versions; track version) {
      <mat-option [value]="version.version_id">
        {{ version.display_name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="button-container">
    <button mat-raised-button color="primary" (click)="onAdd()">Tilføj</button>
    <button
      mat-button
      color="primary"
      (click)="onEdit()"
      [disabled]="!selectedVersion"
    >
      Rediger
    </button>
  </div>
</div>
